import React from "react";
import { CalendarDays, User } from "lucide-react";
import { useLocation } from "react-router-dom";
import { differenceInDays } from "date-fns";
import { useTranslation } from "react-i18next";
import useSurveyActions from "./useSurveyActions";
const SurveyCard = ({ survey, refetch }: { survey: any, refetch: any }) => {

  const { t } = useTranslation();
  const location = useLocation();
  const user = JSON.parse(sessionStorage.getItem('user') || '{}')
  const storedBranding = React.useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem("branding") || '{}');
    } catch (error) {
      return null;
    }
  }, []);
  const appearance = storedBranding?.data?.appearance;
  // Branded culture audits should only show the client's palette — use
  // neutral greys for the blue/green status badges.
  const useNeutralStatus = user?.sub_type === 'culture' && !!appearance?.theme_colour;
  const { takeSurvey, viewResponse, isLoadingQuestions, isReview, overlays } = useSurveyActions({ survey, refetch });

  return (
    <div className="bg-white rounded-xl shadow-sm p-4 w-full  md:max-w-[320px]">
      {overlays}
      <div className="flex items-start justify-between">
        <h2 className="text-lg font-semibold text-gray-900">{survey?.group_title || survey?.survey_title}</h2>
        <div className="flex items-center gap-2">
          {
            parseInt(survey?.progress) === 0 ?
              <span className={`${useNeutralStatus ? 'bg-gray-100 text-gray-700' : 'bg-blue-100 text-darkBlue'} w-[80px] text-center text-xs font-medium px-1 py-0.5 rounded-full`}>
                {t("not-started")}
              </span>
              :
              (parseInt(survey?.progress) >= 100 || survey?.completed_at) ?
                <span className={`${useNeutralStatus ? 'bg-gray-200 text-gray-900' : 'bg-green-100 text-primary'} w-[80px] text-center text-xs font-medium px-1 py-0.5 rounded-full`}>
                  {t("completed")}
                </span>
                :
                <span className="bg-orange-100 w-[80px] text-center text-orange-500 text-xs font-medium px-1 py-0.5 rounded-full">
                  {t("in-progress")}
                </span>
          }
        </div>
      </div>

      {/* Meta Info */}
      {/* <div className="flex items-center text-gray-500 text-md mt-3 gap-2">
        <BookUser className="w-4 h-4" />
        <span>{survey?.exam_title || survey?.survey_title}</span>
      </div> */}
      <div className="flex items-center text-gray-500 text-md mt-1 gap-2">
        <CalendarDays className="w-4 h-4" />
        <span>
          {(() => {
            const today = new Date();
            const endDate = new Date(survey?.end_date);
            const diff = differenceInDays(endDate, today);

            if (diff > 0) return t("days-left", { count: diff });
            if (diff === 0) return t("ends-today");
            return t("expired");
          })()}
        </span>
      </div>

      {location.pathname.includes("/candidate/my-review") &&
        <div className="flex items-center text-gray-500 text-md mt-3 gap-2">
          <User className="w-4 h-4" />
          <span>{survey?.user_name}</span>
        </div>
      }
      {location.pathname.includes("/candidate/my-review") &&
        <div className="flex items-center text-orange-500 text-md mt-3 gap-2" style={{ color: appearance?.theme_colour }}>
          <span>{survey?.review_type}</span>
        </div>
      }
      {/* !location.pathname.includes("/candidate/my-review") &&
        <div className="flex items-center text-gray-500 text-md mt-3 gap-2">
        Overall Rating:
        <span>{survey?.overall_rating || '-'}</span>
      </div>
       */}
      {/* !location.pathname.includes("/candidate/my-review") &&
        <>
          <div className="flex items-center font-semibold text-gray-500 text-md mt-3 gap-2">
            Rating By Section
          </div>
          { !survey?.sectionRatings?.length ? null :
            survey?.sectionRatings?.map((rating: any) => (
              <div className="flex items-center text-gray-500 text-md mt-2 gap-2">
              {rating?.sectionTitle} :
              <span>{rating?.averageRating || '-'}</span>
             </div>
            ))
          }
        </>
       */}
      {/* Progress */}
      <div className="mt-4">
        <div className="text-md text-gray-700 font-medium mb-1">{t("progress")}</div>
        <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
          <div style={{ width: `${parseInt(survey?.progress)}%`, backgroundColor: appearance?.theme_colour }} className="h-full bg-primary"></div>
        </div>
      </div>

      <div className={`${isReview ? 'flex justify-between' : ''} `}>
        {/* Continue Button */}
        <button id="take-survey" onClick={() => takeSurvey(survey)} disabled={isLoadingQuestions} style={{ backgroundColor: (!survey?.completed_at && appearance?.theme_colour) ? appearance.theme_colour : undefined }} className={`w-full mt-4 ${parseInt(survey?.progress) === 0 ? ' bg-orange-500' : /* parseInt(survey?.progress) >= 100 || */ survey?.completed_at ? 'bg-gray-300' : 'bg-orange-500'
          } text-white text-sm font-medium py-2 rounded-md flex justify-center items-center gap-2`}>
          <span>{
         /* parseInt(survey?.progress) === 0 || */ !survey?.completed_at ? isReview ? t('evaluate') : t('take-survey') : /*parseInt(survey?.progress) >= 100 ||*/ survey?.completed_at ? t('completed') : t('continue')}</span>
        </button>
        {false ? <button onClick={() => viewResponse(survey)} className={`w-full mt-4 bg-primary ml-5 text-white text-sm font-medium py-2 rounded-md flex justify-center items-center gap-2`}>
          {t("view-response")}
        </button> : null}
      </div>
    </div>
  );
};

export default SurveyCard;
